import { render, staticRenderFns } from "./CabinetForm.vue?vue&type=template&id=6f8a2577&scoped=true&"
import script from "./CabinetForm.vue?vue&type=script&lang=js&"
export * from "./CabinetForm.vue?vue&type=script&lang=js&"
import style0 from "./CabinetForm.vue?vue&type=style&index=0&id=6f8a2577&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8a2577",
  null
  
)

export default component.exports